module.exports = __webpack_public_path__ + "img/monitor_cover_b.6046511e.png";